import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ShipInvoiceService {
  private apiUrl = '/spring/ships/invoice';

  constructor(private http: HttpService) { }

  printByPick(
    printagentCd: string,
    printerCd: string,
    picknoCd: string,
    pickdetnoCd: string,
    reprintFl: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/pick/print`;
    const jsonInput = {
      printagentCd: printagentCd,
      printerCd: printerCd,
      picknoCd: picknoCd,
      pickdetnoCd: pickdetnoCd,
      reprintFl: reprintFl,
      updprogramCd: updprogramCd
    };
    return this.http.post(url, jsonInput);
  }

  printByShip(
    printagentCd: string,
    printerCd: string,
    selectItems: object[],
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/order/print`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        shiphId: selectItems[i]['shiphId']
      });
    }
    const jsonInput: object = {
      printagentCd: printagentCd,
      printerCd: printerCd,
      ships: jsonUnit,
      updprogramCd: updprogramCd
    };
    return this.http.post(url, jsonInput);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/ship-invoice/ship-invoice.service.ts